/** @format */

// import Page from "../../components/Page";
import {
  Box,
  Card,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  ToggleButton,
  Typography,
} from "@mui/material";
// import Iconify from "../../components/Iconify";
import React from "react";
// import { useNavigate } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import PropTypes from "prop-types";

TemplateForm1.propTypes = {
  name: PropTypes.string,
  language: PropTypes.object,
  category: PropTypes.object,
  languageOptions: PropTypes.array,
  categoryOptions: PropTypes.array,
  setName: PropTypes.func,
  setLanguage: PropTypes.func,
  setCategory: PropTypes.func,
};

export default function TemplateForm1(props) {
  const { name, language, category, languageOptions, categoryOptions } = props;
  // const navigate = useNavigate();

  return (
    <>
      <Card sx={{ p: 4 }}>
        <Stack spacing={2} sx={{ mb: 4 }}>
          <Stack spacing={1}>
            <Typography variant="h6">Category</Typography>
            <Typography paragraph sx={{ fontSize: "0.8em" }}>
              Choose what type of message template you want to create.
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              {categoryOptions.map((obj) => {
                return (
                  <Grid item xs={6} sm={3} sx={{ p: 0 }}>
                    <ToggleButton
                      key={obj.id}
                      value={obj.code}
                      selected={obj.code === category.code}
                      onChange={() => {
                        props.setCategory(obj);
                      }}
                      sx={{ width: "100%" }}
                    >
                      {obj.category}
                    </ToggleButton>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Stack>
        <Stack spacing={1} sx={{ mb: 4 }}>
          <Typography variant="h6">Name</Typography>
          <Typography paragraph sx={{ fontSize: "0.8em" }}>
            Give your message template a name.
          </Typography>
          <TextField
            value={name}
            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
            placeholder="Example: template_message"
            inputProps={{ maxLength: 512 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {name.length}/512
                </InputAdornment>
              ),
            }}
            onChange={(e) => {
              props.setName(
                e.target.value.toLowerCase().replace(/[^a-z\d_]/g, "")
              );
            }}
          />
        </Stack>
        <Stack spacing={1}>
          <Typography variant="h6">Languages</Typography>
          <Typography paragraph sx={{ fontSize: "0.8em" }}>
            Choose which languages your message template will be sent in.
          </Typography>
          <FormControl fullWidth>
            <Select
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              value={language.code}
              MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
              onChange={(e) => {
                props.setLanguage(
                  languageOptions.find((el) => el.code === e.target.value)
                );
              }}
            >
              <MenuItem value="none" disabled>
                Select language...
              </MenuItem>
              {languageOptions.map((obj) => {
                return (
                  <MenuItem key={obj.id} value={obj.code}>
                    {obj.language}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Stack>
      </Card>
    </>
  );
}
